export const PROJECT_SHARING_SOCIAL_NETWORKS =  {
    'twitter': 'twitter',
};
